import { render, staticRenderFns } from "./PostMiddle.vue?vue&type=template&id=1b1cd74d&scoped=true&"
import script from "./PostMiddle.vue?vue&type=script&lang=js&"
export * from "./PostMiddle.vue?vue&type=script&lang=js&"
import style0 from "./PostMiddle.vue?vue&type=style&index=0&id=1b1cd74d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cd74d",
  null
  
)

export default component.exports